import { render, staticRenderFns } from "./WorkFolder.vue?vue&type=template&id=dfdbf1ce&"
import script from "./WorkFolder.vue?vue&type=script&lang=js&"
export * from "./WorkFolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports